import React from "react";
import { styled } from "styled-components";
import { Button, Divider } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import { MainText, ResImage, SubText } from "../../helpers/StyledComponents";

const BookCard = ({ title, subtitle, desc, img, link, showViewBtn }) => {
  return (
    <BookContainer>
      <LeftContainer>
        <ResImage src={img} />
      </LeftContainer>
      <RightContainer>
        {showViewBtn && (
          <Button
            icon={<DownloadOutlined />}
            type="primary"
            href={link}
            target="_blank"
            style={{ position: "absolute", bottom: "20px" }}
          >
            View or Download
          </Button>
        )}
        <MainText>{title}</MainText>
        <Divider style={{ margin: "12px 0px" }} />
        {subtitle && (
          <>
            <MainText fs="15">{subtitle}</MainText>
            <Divider style={{ margin: "12px 0px" }} />
          </>
        )}
        {typeof desc === "string" ? <SubText fs="14">{desc}</SubText> : desc}
      </RightContainer>
    </BookContainer>
  );
};

const BookContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 540px;

  background-color: white;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  @media (max-width: 768px) {
    flex-direction: column;
    height: 100%;
  }
`;

const LeftContainer = styled.div`
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const RightContainer = styled.div`
  width: 50%;
  padding: 20px;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    min-height: 300px;
  }
`;
export default BookCard;
